import React from 'react';
import {DeleteBoxInAdminDashboardSetting} from "../../../Assets/svg";
import {useState} from "react";
import tableImage from "../../../Assets/Images/tableImage.png";

const SampleChart = (props) => {
  const [showOptions, setShowOptions] = useState(false);
  return (<>
    <div style={{
      width: '367px',
      height: '270px',
      background: '#FFFFFF',
      boxShadow: '0px 3px 4px 2px rgba(0, 0, 0, 0.05)',
      borderRadius: '10px',
      padding: '30px 20px',
      overflow: 'hidden',
      margin: '10px 0'
    }}

         className={"position-relative"}
         onMouseOver={() => setShowOptions(true)}
         onMouseLeave={() => setShowOptions(false)}
    >


      <>
        {showOptions && <>
          <div onClick={props.onDelete} className={"position-absolute"} style={{
            top: 10,
            right: 10,
            cursor: 'pointer',
          }}
          title={"حذف"}
          >
            <DeleteBoxInAdminDashboardSetting/>
          </div>
          <div
            onClick={props.onEdit}
            className={"position-absolute"}
            style={{
              cursor: 'pointer',
              top: 10,
              right: '50px'
            }}
            title={"ویرایش"}>
            <i className="fas fa-edit fa-1x" style={{color: "gray"}}/>
          </div>
        </>}
      </>


      {props.entity === "table" ?
        <>
          <div style={{width: '362px'}} className={"d-flex justify-content-center"}>
            <img alt={"altImage"} src={tableImage}/>
          </div>
        </> :
        <>
          <div>
            <svg width="320" height="194" viewBox="0 0 320 194" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.45898 0V192.888H319.25" stroke="#494949"/>
              <path
                d="M4.3125 98.1512L64.9102 105.833L97.3427 81.5082L151.112 59.3175L175.864 42.6744L208.296 59.3175L252.251 42.6744L309.861 59.3175V192.035H4.3125V98.1512Z"
                fill={props.color !== undefined ? props.color : "#6ACBD8"}/>
              <path d="M6.01937 182.646H0.898438" stroke="#494949"/>
              <path d="M6.01937 170.698H0.898438" stroke="#494949"/>
              <path d="M6.01937 158.749H0.898438" stroke="#494949"/>
              <path d="M6.01937 146.8H0.898438" stroke="#494949"/>
              <path d="M6.01937 134.851H0.898438" stroke="#494949"/>
              <path d="M6.01937 122.902H0.898438" stroke="#494949"/>
              <path d="M6.01937 110.953H0.898438" stroke="#494949"/>
              <path d="M6.01937 99.0046H0.898438" stroke="#494949"/>
              <path d="M6.01937 87.0558H0.898438" stroke="#494949"/>
              <path d="M6.01937 75.107H0.898438" stroke="#494949"/>
              <path d="M6.01937 63.1581H0.898438" stroke="#494949"/>
            </svg>
          </div>
        </>}

      <div className={'text-center my-3'}>
        {props.title}
      </div>
    </div>
  </>);
};

export default SampleChart;
